import React, { Component } from 'react'
import Flickity from 'flickity'
import { BaseTemplateStyle, flickitySlideStyle } from './../../styles'
import { Prodibi } from './../../components'

export default class BaseTemplate extends Component {

  componentDidMount() {
    if (this.props.images) {
      this.flkty = new Flickity( this.slider, {
        lazyLoad: 1,
      })
    }
  }

  render() {
    const {type, title, titleBis, description, descriptionBis, image, images} = this.props

    return (
      <div className={`product-template--base product-template template ${BaseTemplateStyle(
          image && image.type === 'file' ? image.url : '', type
        )}`}>
        <div className="template-scroll">
          <div className="template-left">
            {
              images && (
                <div className="flickity-slider" ref={(flickity) => this.slider = flickity}>
                  {
                    images.map((image, index) => (
                      <div className={`flickity-slide ${ flickitySlideStyle(  image.type === 'file' ? image.url : '') }`} key={index}>
                        {
                          image.type === 'prodibi' && 
                          <Prodibi
                            id={image.reference}
                            width={image.width}
                            height={image.height}
                          />
                        }
                      </div>
                    ))
                  }
                </div>
              )
            }
          </div>
          <div className="template-right template-content">
              { title && ( <h2 className="subtitle">{title}</h2> ) }
              { description && ( <div className="content" dangerouslySetInnerHTML={{__html: description}} /> )}
              { titleBis && ( <h2 className="subtitle">{titleBis}</h2> )}
              { descriptionBis && ( <div className="content" dangerouslySetInnerHTML={{__html: descriptionBis}} /> )}
          </div>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/SliderTemplates/BaseTemplate.js